export default "__VITE_ASSET__beso5pXW__"